import { ContactMail, Person, PersonAdd, LocalPhone, Apartment, LocationCity, Email, Lock, Language } from '@mui/icons-material';
import { Box, FormControl, Grid, TextField, RadioGroup, FormControlLabel, Radio, Button, InputLabel, Select, MenuItem } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import './register.css';
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { registerDC, reset as authReset } from '../../features/auth/authSlice';

// 1. Removed imports for Redux (getAllCounty, commonReset) and lodash. Added axios.
import axios from 'axios';

import { toast } from 'react-toastify'
import Spinner from '../Layout/Spinner';
import config from '../../utils/Config';
import authService from '../../features/auth/authService';

const EMAIL_NAME_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PASSWORD_NAME_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/;
const NAME_REGEX = /^[A-Za-z]{2,20}$/;
const PHONE_REGEX = /^\d{3}-\d{3}-\d{4}$/;
const ZIP_REGEX = /^[0-9]{5}$/;

function Register(props) {

    useEffect(() => {
        document.title = props.title;
    }, []);

    const [dfValue, setdfValue] = useState('no');
    const [countyValue, setcountyValue] = useState();
    const [distValue, setDistValue] = useState();
    const [distList, setDistList] = useState([]);
    
    // 2. Added local state to replace Redux common slice properties
    const [countyList, setCountyList] = useState([]);
    const [countiesLoading, setCountiesLoading] = useState(true);

    const dispatch = useDispatch();
    const navigate = useNavigate()

    let { isError: authIsError, isSuccess: authIsSuccess, isLoading: authIsLoading, message: authMessage } = useSelector(
        (state) => state.auth
    )
    const { register, handleSubmit, formState: { errors }, watch, reset: resetRegiterForm } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: {
            directlyFunded: "no" 
        }
    });

    // 3. Load the new lightweight counties endpoint
    const loadCounties = async () => {
        try {
            const response = await axios.get(
                config.basePath + 'common/registration/counties'
            );
            setCountyList(response.data.counties || []);
        } catch (err) {
            toast.error('Unable to load counties');
        } finally {
            setCountiesLoading(false);
        }
    };
    
    // 3. Execute loadCounties on component mount
    useEffect(() => {
        loadCounties();
    }, []);

    // 6. Fixed district filtering by removing the directlyFunded logic entirely
    useEffect(() => {
        if (countyValue) {
            let filterCounty = countyList.find(
                val => val._id === countyValue
            );
            setDistList(
                filterCounty?.districts
                    ? [...filterCounty.districts].sort((a, b) =>
                          a.name.localeCompare(b.name)
                      )
                    : []
            );
        } else {
            setDistList([]);
        }
    }, [countyValue, countyList]);

    useEffect(() => {
        // 4. Removed common slice error handling (commonIsError check) from this block

        if (authIsError) {
            toast.error(authMessage);
            authIsError = false;
        }

        if (authIsSuccess) {
            toast.success(authMessage)
            resetRegiterForm()
            setcountyValue('')
            authIsSuccess = false
        }
    }, [authIsSuccess, authIsError, authMessage, navigate, dispatch, resetRegiterForm])

    // 5. Removed common reset logic from handleNextPage
    const handleNextPage = () => {
        // Function intentionally left blank or reserved for future authReset
    }

    const handleDFChange = (event) => {
        setdfValue(event.target.value)
    }

    const formatPhoneNumber = (value) => {
        const cleaned = ('' + value).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
        if (match) {
            const part1 = match[1]; 
            const part2 = match[2]; 
            const part3 = match[3]; 
            return [part1, part2, part3].filter(Boolean).join('-').replace(/-$/, ''); 
        }
        return value; 
    };

    const handlePhoneChange = (event) => {
        const { value } = event.target;
        const formattedValue = formatPhoneNumber(value); 
        event.target.value = formattedValue; 
    };

    const onSubmit = (userData) => {
        authService.register(userData).then((result) => {
            console.log(result);
            toast.success(result.message ? result.message : "This email address is already associated with an account. Please click “Already a member. Sign in” to log in.")
            
            setTimeout(() => {
                window.location.reload();
            }, 7000);
        }).catch(err => {
            toast.error(err?.response?.data?.message ? err.response.data.message : "Error in registration");
        })
    }

    const onError = () => {
        if (Object.keys(errors).length >= 0) {
            toast.error("At least one field on this form is missing or invalid.");
        }
    };

    const oncountyChange = (event) => {
        setcountyValue(event.target.value)
    }

    function onDistChange(event) {
        setDistValue(event.target.value)
    }

    const sortedCountyList = countyList.slice().sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });

    return (
        <>
            {/* 7. Updated Spinner to check local countiesLoading state instead of commonIsLoading */}
            {(countiesLoading || authIsLoading) ? <Spinner></Spinner> : ''}
            <form onSubmit={handleSubmit(onSubmit, onError)}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={0} style={{ marginTop: '20px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={5.4}>
                            <div className="contentLeft" style={{ marginTop: "10px" }}>
                                <img src={require('../../assets/images/menuHeader_new.png')} alt="calSchls" className="reg-logo-img" />
                                <div className="logo-sub-title">
                                    <span className="reg-cordinator-portal">CalSCHLS Coordinator Portal</span>
                                </div>
                            </div>
                        </Grid>

                        <Grid item xs={4}>
                            <div className="contentRight">
                                <img src={require('../../assets/images/wested.png')} alt="wested" style={{ height: '90px', width: '375px' }} />
                            </div>
                        </Grid>
                        <Grid item xs={1}></Grid>
                    </Grid>
                    
                    <Grid container spacing={0} style={{ marginTop: '40px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={6}>
                            <div className="contentLeft regcel">
                                <span>Registration for </span>
                                <span style={{ borderBottom: '2px solid #003c68' }}>District</span>
                                <span> Coordinator</span>
                            </div>
                        </Grid>
                        <Grid item xs={4}>
                            <div className="contentRight aaml">
                                <Link to={"/login"} className="signInTxt" onClick={handleNextPage}>
                                    <span>Already a member? Sign in </span>
                                </Link>
                            </div>
                        </Grid>
                        <Grid item xs={1}></Grid>
                    </Grid>
                    
                    <Grid container spacing={0} style={{ marginTop: '60px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Person sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="firstName" name="firstName" label="First Name" variant="standard" sx={{ width: '90%' }}
                                    {...register('firstName', { required: true, minLength: 2, maxLength: 20, pattern: NAME_REGEX })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            
                            {errors.firstName && errors.firstName.type === "required" && (
                                <span className="errorClass">Enter <b>first name</b></span>
                            )}
                            {errors.firstName && (errors.firstName.type === "minLength" || errors.firstName.type === "maxLength" || errors.firstName.type === "pattern") && (
                                <span className="errorClass">Last name must be between 2 and 20 characters long, no numbers allowed.</span>
                            )}
                        </Grid>
                        
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <PersonAdd sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="lastName" name="lastName" label="Last Name" variant="standard" sx={{ width: '100%' }}
                                    {...register('lastName', { required: true, minLength: 2, maxLength: 20, pattern: NAME_REGEX })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            
                            {errors.lastName && errors.lastName.type === "required" && (
                                <span className="errorClass">Enter <b>last name</b></span>
                            )}
                            {errors.lastName && (errors.lastName.type === "minLength" || errors.lastName.type === "maxLength" || errors.lastName.type === "pattern") && (
                                <span className="errorClass">Last name must be between 2 and 20 characters long, no numbers allowed.</span>
                            )}
                        </Grid>
                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: '15px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <ContactMail sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="email" name="email" label="Email" variant="standard" sx={{ width: '90%' }}
                                    {...register('email', { required: true, pattern: EMAIL_NAME_REGEX })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            
                            {errors.email && errors.email.type === "required" && (
                                <span className="errorClass">Enter <b>email</b></span>
                            )}

                            {errors.email && (errors.email.type === "pattern") && (
                                <span className="errorClass">
                                    Email must be a valid email address
                                </span>
                            )}
                        </Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <LocalPhone sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="phone" name="phone" label="Phone Number" variant="standard" sx={{ width: '100%' }}
                                    {...register('phone', { required: true, pattern: PHONE_REGEX, maxLength: 12 })}
                                    onChange={handlePhoneChange} 
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            
                            {errors.phone && errors.phone.type === "required" && (
                                <span className="errorClass">Enter <b>phone number</b></span>
                            )}
                            {errors.phone && (errors.phone.type === "pattern" || errors.phone.type === "maxLength") && (
                                <span className="errorClass">
                                    Please enter a valid 10-digit <b>phone number</b>
                                </span>
                            )}
                        </Grid>
                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: '15px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Apartment sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="address" name="address" label="Mailing Address" variant="standard" sx={{ width: '90%' }}
                                    {...register('address', { required: true })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            
                            {errors.address && errors.address.type === "required" && (
                                <span className="errorClass">Enter <b>mailing address</b></span>
                            )}
                        </Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <LocationCity sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="city" name="city" label="City" variant="standard" sx={{ width: '100%' }}
                                    {...register('city', { required: true })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            
                            {errors.city && errors.city.type === "required" && (
                                <span className="errorClass">Enter <b>city</b></span>
                            )}
                        </Grid>
                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: '15px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Email sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="zipCode" name="zipCode" label="Zip Code" variant="standard" sx={{ width: '90%' }}
                                    {...register('zipCode', { required: true, pattern: ZIP_REGEX, maxLength: 5 })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>

                            {errors.zipCode && errors.zipCode.type === "required" && (
                                <span className="errorClass">Enter <b>zip code</b></span>
                            )}
                            {errors.zipCode && (errors.zipCode.type === "pattern" || errors.zipCode.type === "maxLength") && (
                                <span className="errorClass">
                                    Zip code should contain only digit, Zip code must be 5-digit
                                </span>
                            )}
                        </Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Grid container spacing={0} style={{ marginTop: '15px' }}>
                                    <Grid item xs={5.8}>
                                        <div className="regInfoMsg">
                                            Directly funded charter school
                                        </div>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl style={{ color: '#003c68', fontSize: '16px' }}>
                                            <RadioGroup
                                                row
                                                aria-labelledby="radio-buttons-group-label"
                                                defaultValue="no"
                                                name="directlyFunded"
                                                onChange={handleDFChange}>
                                                <FormControlLabel value="yes" control={<Radio sx={{
                                                    '&.Mui-checked': {
                                                        color: '#3f51b5',
                                                    },
                                                }} />} label="Yes"
                                                    {...register("directlyFunded")}
                                                />
                                                <FormControlLabel value="no" control={<Radio sx={{
                                                    '&.Mui-checked': {
                                                        color: '#f44336',
                                                    },
                                                }} />} label="No"
                                                    {...register("directlyFunded")}
                                                />
                                                <FormControlLabel value="both" control={<Radio sx={{
                                                    '&.Mui-checked': {
                                                        color: '#ff4081',
                                                    },
                                                }} />} label="Both"
                                                    {...register("directlyFunded")}
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: '15px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Language sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 1.5 }} />
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 120, width: '100%' }}>
                                    <InputLabel id="county-label" sx={{ color: '#003c68' }}>Select a county</InputLabel>
                                    <Select
                                        labelId="county"
                                        id="county"
                                        label='Select a county'
                                        sx={{ width: '95%' }}
                                        value={countyValue || ""}
                                        {...register("county", { required: true })}
                                        onChange={oncountyChange}
                                        MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                                    >
                                        <MenuItem value="">
                                            <em>Select a county</em>
                                        </MenuItem>
                                        {sortedCountyList.map((cVal) => (
                                            <MenuItem key={cVal._id} value={cVal._id}>{cVal.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            
                            {errors.county && errors.county.type === "required" && (
                                countyValue ? '' : <span className="errorClass">Select a <b>county</b></span>
                            )}
                        </Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <LocationCity sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 1.5 }} />
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 120, width: '100%' }}>
                                    <InputLabel id="district-label" sx={{ color: '#003c68' }}>Select a district</InputLabel>
                                    <Select
                                        labelId="district-label"
                                        id="district"
                                        name='district'
                                        label="Select a district"
                                        value={distValue || ""}
                                        sx={{ width: '100%' }}
                                        {...register("district", { required: true })}
                                        onChange={onDistChange}
                                        MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                                    >
                                        <MenuItem value="">
                                            <em>Select a district</em>
                                        </MenuItem>
                                        {distList.map((dVal) => (
                                            <MenuItem key={dVal._id} value={dVal._id}>{dVal.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            
                            {errors.district && errors.district.type === "required" && (
                                distValue ? '' : <span className="errorClass">Select a <b>district</b></span>
                            )}
                        </Grid>
                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: '15px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Lock sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="password" name="password" label="Password" variant="standard" sx={{ width: '90%' }} type="password"
                                    {...register('password', { required: true, pattern: PASSWORD_NAME_REGEX })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>

                            {errors.password && errors.password.type === "required" && (
                                <span className="errorClass">Enter a <b>password</b></span>
                            )}
                            {errors.password && (errors.password.type === "pattern") && (
                                <span className="errorClass">
                                    Password must contain at least one number, one lowercase letter, and one uppercase letter, and be between 6 and 15 characters long.
                                </span>
                            )}
                        </Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Lock sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="cpassword" name="cpassword" label="Confirm Password" variant="standard" sx={{ width: '100%', color: "#003c68" }} type="password"
                                    {...register('cpassword', {
                                        required: true,
                                        validate: (value) => {
                                            if (watch('password') !== value)
                                                return "Your passwords do no match";
                                        }
                                    })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            
                            {errors.cpassword && errors.cpassword.type === "required" && (
                                <span className="errorClass">Enter a <b>matching Password</b></span>
                            )}

                            {errors.cpassword && (
                                <span className="errorClass">Passwords do not match</span>
                            )}
                        </Grid>
                    </Grid>

                    <Grid container
                        spacing={0}
                        style={{ marginTop: '40px' }}
                        direction="column"
                        alignItems="center"
                        justifyContent="center">
                        <Grid item xs={12}>
                            <Button type="submit" className='signup' sx={{
                                textAlign: 'center', height: 40, backgroundColor: '#003c68',
                                width: 620, borderRadius: 25, color: '#fff', ':hover': {
                                    bgcolor: '#003c68',
                                    color: 'white',
                                },
                            }}
                            >Create an account</Button>
                        </Grid>
                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: '15px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={8.8}>
                            <div className="regInfoMsg">
                                Once your account has been created, your CalSCHLS TA must approve your account before you can begin registering
                                for the survey. You will be sent an email once your account has been approved.
                            </div>
                        </Grid>
                    </Grid>
                </Box >
            </form>
        </>
    )
}

export default Register